// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2MsTf","noInteraction":"EventWrapper_noInteraction__1XajV","pointerPassthrough":"EventWrapper_pointerPassthrough__1DzmU"};